import { Injectable } from '@angular/core';
import { UsuarioToken } from './session-return-jwt.model';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor() {}
  decodeJwt(token: string): UsuarioToken | null {
    try {
      const payload = token.split('.')[1];
      const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
      const padded = base64.padEnd(base64.length + (4 - base64.length % 4) % 4, '=');
      const decodedStr = atob(padded);
      const jsonObject = JSON.parse(decodedStr);
      const decodedJson = JSON.parse(jsonObject) as UsuarioToken;
      return decodedJson;
  
    } catch (error) {
      console.error('Erro ao decodificar o token:', error);
      return null;
    }
  }
}
